module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "left_window column"
  }, [_c('sm-phone-header'), _vm._v(" "), _c('h1', {
    staticClass: "title_page"
  }, [_vm._v("Кабинет врача")]), _vm._v(" "), _c('user-notifications', {
    attrs: {
      "user-type": 'worker'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top_btns_wrap"
  }, [_c('div', {
    staticClass: "begin_reception add_value hover-bg",
    on: {
      "click": _vm.createMomentalEvent
    }
  }, [_vm._v("\n\t\t\t\tНачать прием без предварительной записи\n\t\t\t")])]), _vm._v(" "), _c('coming-visit'), _vm._v(" "), _c('user-events', {
    attrs: {
      "user-type": 'worker'
    }
  }), _vm._v(" "), _c('sm-phone-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "right_window column"
  }, [_c('large-scheduler', {
    attrs: {
      "isDoctor": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed595c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DoctorPage.vue
// module id = 628
// module chunks = 0